import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import md5 from 'blueimp-md5';

import AuthInput from '../Personal/AuthInput';
import VerifyCardId from '../Personal/VerifyCardId';
import SetPayPwd from '../Personal/SetPayPwd';
import SetPayPwdAgain from '../Personal/SetPayPwdAgain';

class Password extends Component {
  constructor() {
    super();
    this.state = {
      step: 1,
      authCode: '',
      cardId: '',
      firstPwd: '',
      againPwd: ''
    }
  }

  pwdSuccess = (value) => {
    this.setState({
      step: 2,
      authCode: value
    })
  }

  cardIdSuccess = (value) => {
    this.setState({
      step: 3,
      cardId: value
    })
  }

  pwdFirstSuccess = (value) => {
    this.setState({
      step: 4,
      firstPwd: value
    })
  }

  pwdAgainSuccess = (value) => {
    if (value !== this.state.firstPwd) {
      Toast.info('两次交易密码输入不一致！', 2);
      this.setState({
        step: 3,
        firstPwd: ''
      })
      return;
    }
    this.setState({
      againPwd: value
    }, () => {
      this.submit();
    })
  }

  submit = async () => {
    const path = '/spread/web/user/payPassword';
    const postData = {
      authCode: this.state.authCode,
      cardId: this.state.cardId,
      password: md5(this.state.againPwd)
    }
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      this.props.history.goBack();
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  render () {
    const { step } = this.state;
    let password = {
      padding: '0.42rem 0.64rem 0',
      position: 'absolute',
      boxSizing: 'border-box',
      width: '100%',
      height: '100%',
      backgroundColor: '#fff'
    }
    return (
      <div style={password}>
        {step === 1 && <AuthInput pwdSuccess={this.pwdSuccess}></AuthInput>}
        {step === 2 && <VerifyCardId cardIdSuccess={this.cardIdSuccess}></VerifyCardId>}
        {step === 3 &&<SetPayPwd pwdFirstSuccess={this.pwdFirstSuccess}></SetPayPwd>}
        {step === 4 && <SetPayPwdAgain pwdAgainSuccess={this.pwdAgainSuccess}></SetPayPwdAgain>}
      </div>
    )
  }
}

export default Password;